import { RefObject, useEffect } from 'react'
import { useVideoContext } from '../../ActiveVideoContext'

type HookProps = {
  id: string
  videoRef: RefObject<HTMLVideoElement>
  isOnScreen?: boolean
  canPlayInModal?: boolean
}

export const SLIDE_TRANSITION_DELAY = 250

const useSetActiveVideo = ({
  id,
  videoRef,
  isOnScreen,
  canPlayInModal,
}: HookProps) => {
  const { activeVideo, register, setActiveVideo } = useVideoContext()

  useEffect(() => {
    if (!videoRef.current) return

    register(id, videoRef, canPlayInModal ? 'modal' : 'inline')
  }, [id, videoRef, register])

  useEffect(() => {
    const gallery = document.getElementById('media_gallery')
    const video = videoRef.current

    const isGallery = video && gallery && gallery.contains(video)

    if (!isGallery && isOnScreen) {
      setActiveVideo({
        id,
        ref: videoRef,
      })
      return
    }

    if (isGallery && isOnScreen) {
      const timeoutId = setTimeout(() => {
        setActiveVideo({
          id,
          ref: videoRef,
        })
      }, SLIDE_TRANSITION_DELAY)

      return () => {
        clearTimeout(timeoutId)
      }
    }
  }, [id, videoRef, isOnScreen, setActiveVideo])

  return [activeVideo, setActiveVideo] as const
}

export default useSetActiveVideo
